module.exports = __webpack_public_path__ + "static/media/uploadPhotoButton.8dccefa5.svg";